export const  UiAccessList = {
  GetParameters : [2801],
  SubmitParameters : [2802],
  GetSymptomsByDiseaseId : [2803],
  RuleEngineReport : [3507],
  AiReport : [3508],
  SmartReport : [3509],
  Report: [2804, 2805, 2806],
  Charts : [3510],
  OldReports : [3511],
  UploadReport : [3512],
  Prescriptions : [3513],
  DownloadSmartReport : [2811],
  ShareReport : [2812],
  Profile : [2813],
  Laboratory : [3000],
  ReportRating: 3501,
  DoctorDiagnosis : 3502,
  Diagnosis: 3503,
  RadiologyFinding : 3504,
  Medication : 3505,
  OtherHealthInfo : 3506,
  EngineReport : 3507,
  Vhs : 3514,
  EnableLog : 3515,
  PlanOfAction: 3516,
  PromptView: 3517,
  History: 3518,
  Examination: 3519,
  ComparisonTable: 3520,
  ReportComparison: 3521,
  DocumentScanner: 3522, //Medical record -> text extractor
  MedicalRecord: 3523,  //medical record -> normal user
  SpecializedFeature: 3925, //Medical record -> Specialized feature (org)
  Insurance: 3922,
  DocSegregation: 3923,
  InsurancePdfDownload: 3924,
  ClaimHistory: 3927,
  PreAuth: 3928,
  Radiology: 4421,
  Dashboard: 3524,
  MedicalRecordDashboard: 2814,
  MedicalRecordAnalysis: [4521, 4522],
  CompareMedicalRecord: [4523],
  MedicalRecordHistory: [4506],
  PDFSettings: [4701],
  ICDCodeAnalysis: [4822],
  IcdCodeHistory: [5014],
  ManualEntry: 3525,
  EmrAnalyze: 4524,
  SpecialityEmrAnalyze: 4525,
  AnalyzeEmrRecords: 4526,
  CompareLabReports: 4527,
  CompareClinicalData: 4528,
  GenerateReferralLetter: 4529,
  GeneratePatientMail: 4530,
  GenerateInsuranceReport: 4531,
  GenerateDischargeSummary: 4532,
  GeneratePrescription: 4533,
  AnalyzeOct: 4534,
  ExtractInput : 4536,
  AnalyzeIcu: 4537,
  RiskScore: 3526
}
